<ah-router-modal [hideClose]="true" #modal="ahModal">
  <div slot="modal-body">
    <ah-time-log [modal]="modal" [routeParamType]="routeParamType" [taskId]="taskId" [projectId]="projectId" [startDate]="startDate" [endDate]="endDate"></ah-time-log>
  </div>
</ah-router-modal>
